import React from "react";
import { EHR_LOGOS } from "../lib/site-data";
import { LogoMarquee } from "./LogoMarquee";

export const EHRShowcase = () => (
  <section
    id="ehr"
    data-testid="ehr-section"
    className="py-16 md:py-20 bg-white border-y border-slate-200"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-green-100 text-[color:var(--brand-green-700)] px-4 py-1.5 text-xs font-bold tracking-[0.2em] uppercase">
            EHR & PM Platforms
          </span>
          <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold text-navy">
            Hands-on expertise across every major US EHR.
          </h2>
        </div>
        <p className="text-slate-600 max-w-md">
          Our team has operated across the platforms your practice already uses — nothing to rip,
          nothing to replace.
        </p>
      </div>

      <div className="mt-10">
        <LogoMarquee logos={EHR_LOGOS} testIdPrefix="ehr" itemHeight="h-12" />
      </div>
    </div>
  </section>
);
